import axios from 'axios';
import { message } from 'antd';
import {
  PAYOUT_API,
} from '../../../constants/API';
import {
  CREATE_PAYOUT_LOADING
} from '../types';


function createPayout(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: CREATE_PAYOUT_LOADING,
        creatingPayout: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        await axios.post(PAYOUT_API, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        dispatch({
          type: CREATE_PAYOUT_LOADING,
          creatingPayout: false
        });
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: CREATE_PAYOUT_LOADING,
          creatingPayout: false
        });
        console.log(e);
      }
  }
}
export default createPayout;
